import React, { useState, useEffect } from "react";
import RichTextEditor from "globalComponents/RichTextEditor";

const PlainNotes = ({ caseDetails, readOnly: isCaseReadOnly, onChange }) => {
    const [plainNotesContent, setPlainNotesContent] = useState("");

    useEffect(() => {
        setPlainNotesContent(caseDetails.assessment);
    }, [caseDetails]);

    const handleEditorSave = async (value) => {
        setPlainNotesContent(value);
        onChange("assessment", value);
    };

    return (
        <RichTextEditor
            value={plainNotesContent}
            readOnly={isCaseReadOnly}
            onSave={handleEditorSave}
        />
    );
};

export default PlainNotes;
